export default (num = '') => {
    const str = num.replace(/\$|,/g, '')
    return parseFloat(str)
}
